import {DOWNLOAD_RECOMMENDATIONS_EXCEL, GET_RECOMMENDATIONS, GET_THERAPIST_LIST} from '../../../constants'

export function getTherapistList(data) {
    return {
        type: GET_THERAPIST_LIST,
        data
    };
}


export function getRecommendations(data) {
    return {
        type: GET_RECOMMENDATIONS,
        data
    };
}


export function downloadRecommendationsExcel(data) {
    return {
        type: DOWNLOAD_RECOMMENDATIONS_EXCEL,
        data
    };
}
